import type { CuratedStory } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
} from "~utils/moduleIntegrity";

interface StoryPackageOpinionAuthorIntegrityProps {
    items?: CuratedStory[];
}

export default function integrityCheck({
    items,
}: StoryPackageOpinionAuthorIntegrityProps): IntegrityStatus {
    return checkItemArrayIntegrity(items, ["byline", "headline"]);
}
